import { reportError } from "@cabocheck/shared";
import { useEffect, useState } from "react";

export function QRCodeDisplay({ url, size = 128 }: { url: string; size?: number }) {
  const [qrDataUrl, setQrDataUrl] = useState<string>("");
  useEffect(() => {
    let active = true;
    import("qrcode")
      .then((QRCode) => QRCode.toDataURL(url, { width: size, margin: 1 }))
      .then((dataUrl) => {
        if (active) setQrDataUrl(dataUrl);
      })
      .catch((error) => reportError("QR generation failed", error));
    return () => {
      active = false;
    };
  }, [url, size]);
  return qrDataUrl ? (
    <img src={qrDataUrl} alt="QR Code" className="rounded border bg-white p-1" style={{ width: size, height: size }} />
  ) : (
    <div className="animate-pulse rounded border bg-gray-200" style={{ width: size, height: size }} />
  );
}
